<template>
  <m-a :href="contentLink">
    <m-card907>
      <template #p-1>
        <div class="p-5 text-center">
          <h3 class="text-dark ">{{ content.title }}</h3>
          <hr>
          <p class="text-dark" v-html="content.abstraction"></p>
        </div>
      </template>
      <template #p-2><p></p></template>
    </m-card907>
  </m-a>
</template>

<script>
import {CardComputed} from "./CardComputed";
import mCard907 from "../../Cards/Card907";
import mA from '../../Tags/A'

export default {
  name: "ContentCard907",
  components: {mCard907, mA},
  props: {
    content: {}
  },
  computed: {
    ...CardComputed
  }
}
</script>

<style scoped>

</style>